class Wishlist {
  constructor() {
    this.isWishlistPage = false
    this.storageKey = 'm-wishlist-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.wishlist'
    this.addedClass = 'added-to-wishlist'
    this.hasItemClass = 'wishlist-has-item'
    this.perPage = 12
    this.currentPage = 1
    this.selectors = {
      container: '.m-wishlist-page-content__wrapper',
      pagination: '.m-wishlist-pagination',
      noProducts: '.m-wishlist-no-products',
      wrapper: '.m-wishlist-card',
      productCard: '.m-product-card',
      wishlistButton: '.m-wishlist-button',
      wishlistText: '.m-wishlist-button-text',
      removeButton: '.m-wishlist-remove-button',
      count: '.m-wishlist-count'
    }
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])))
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate
    this.init()
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage()
      this.addEventToRemoveButtons()
      this.addEventToPagination()
    }
    this.setWishlistButtonsState()
    this.addEventToWishlistButtons()
    this.updateWishlistCount()
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

  setWishlistButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.wishlistButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true)

        if (this.isWishlistPage) {
          btn.classList.remove(this.selectors.wishlistButton.replace('.', ''))
          btn.classList.add(this.selectors.removeButton.replace('.', ''))
        }
      }
    })
  }

  updateWishlistCount = () => {
    const size = this.products.length
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
      if (size < 1) {
        elem.classList.add('m:hidden')
      } else {
        elem.classList.remove('m:hidden')
      }
    })
    const method = size ? 'add' : 'remove'
    document.body.classList[method](this.hasItemClass)
  }

  addEventToWishlistButtons = () => {
    addEventDelegate({
      selector: this.selectors.wishlistButton,
      handler: (e, btn) => {
        e.preventDefault()
        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass)
          this.toggleButtonState(btn, active)
          this.updateWishlistCount()

          document.querySelectorAll(this.selectors.wishlistButton).forEach(btnItem => {
            if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
              const isAdded = !btnItem.classList.contains(this.addedClass)
              this.toggleButtonState(btnItem, isAdded)
            }
          })
        }
      }
    })
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText)

    if (active) {
      this.addToWishlist(productHandle)
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromWishlist(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText
      wishlistText.dataset.revertText = wishlistText.textContent
      wishlistText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()
        const prod = btn && btn.closest(this.selectors.wrapper)
        prod && prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          this.removeFromWishlist(productHandle)
          delete this.productNodes[productHandle]
          this.updateWishlistCount()
          if (!this.availableProducts.length) {
            this.showNoProductsMessage()
          } else {
            this.renderPage(this.currentPage)
          }
        }
      }
    })
  }

  wishlistRemoveButton(prdHandle) {
    const html = `<svg class="m-svg-icon--medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`;
    const button = document.createElement("DIV");
    button.classList.add("m-tooltip", "m-wishlist-remove-button", "m:block", "md:m:hidden");
    button.setAttribute("data-product-handle", prdHandle);
    button.innerHTML = html;
    return button;
  }

  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container)
    if (container) {
      let noItemAvailable = true
      if (this.products.length) {
        const promises = this.products.map(async hdl => {
          const url = formatUrl('products', hdl, 'view=grid-card-item')
          const prodHTML = await fetchCache(url)
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m:column", "m-wishlist-card");
          item.innerHTML = prodHTML
          if (item.querySelector(this.selectors.productCard)) {
            noItemAvailable = false
            item.appendChild(this.wishlistRemoveButton(hdl));
            this.productNodes[hdl] = item
          }
        })

        await Promise.all(promises)

        this.renderPage(1)
      }

      if (noItemAvailable) {
        this.showNoProductsMessage()
      } else {
        this.setWishlistButtonsState()
      }

      container.classList.add('is-visible')
    }
  }

  // Produtos salvos que renderizaram um card (ignora os que sairam da loja)
  get availableProducts() {
    return this.products.filter(hdl => this.productNodes[hdl])
  }

  renderPage = (page) => {
    const container = document.querySelector(this.selectors.container)
    if (!container) return

    const items = this.availableProducts
    const totalPages = Math.max(1, Math.ceil(items.length / this.perPage))
    this.currentPage = Math.min(Math.max(1, page), totalPages)

    const start = (this.currentPage - 1) * this.perPage
    container.innerHTML = ''
    items.slice(start, start + this.perPage).forEach(hdl => {
      const prod = this.productNodes[hdl]
      container.appendChild(prod)
      prod.classList.remove('m:hidden')
    })

    if (MinimogTheme.CompareProduct) {
      MinimogTheme.CompareProduct.setCompareButtonsState()
    }

    this.setWishlistButtonsState()
    this.renderPagination(totalPages)
  }

  renderPagination = (totalPages) => {
    const wrapper = document.querySelector(this.selectors.pagination)
    if (!wrapper) return

    if (totalPages <= 1) {
      wrapper.innerHTML = ''
      wrapper.classList.add('m:hidden')
      return
    }

    const parts = []
    if (this.currentPage > 1) {
      parts.push(`<span class="deco"><a href="#" rel="prev" data-page="${this.currentPage - 1}">&laquo;</a></span>`)
    }
    for (let i = 1; i <= totalPages; i++) {
      parts.push(
        i === this.currentPage
          ? `<span class="page current">${i}</span>`
          : `<span class="page"><a href="#" data-page="${i}">${i}</a></span>`
      )
    }
    if (this.currentPage < totalPages) {
      parts.push(`<span class="deco"><a href="#" rel="next" data-page="${this.currentPage + 1}">&raquo;</a></span>`)
    }

    wrapper.innerHTML = parts.join('')
    wrapper.classList.remove('m:hidden')
  }

  addEventToPagination = () => {
    addEventDelegate({
      selector: `${this.selectors.pagination} [data-page]`,
      handler: (e, link) => {
        e.preventDefault()
        this.renderPage(parseInt(link.dataset.page, 10))
        const container = document.querySelector(this.selectors.container)
        container && container.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)

    container.classList.add('m:hidden')
    noProducts.classList.remove('m:hidden')
  }
}

MinimogTheme.Wishlist = new Wishlist()